let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}

/* ===== Help Scout Beacon : affichage mobile (ajoute par Claude, theme de test) =====
 * Sur mobile (< 990 px) :
 *   - bouton en icone seule (60 px) au lieu de la pastille "Aide" de 105 x 60 px ;
 *   - colle au coin bas-gauche (16 px) au lieu de 40 px ;
 *   - remonte automatiquement au-dessus de la barre "Ajouter au panier" collante des fiches produit
 *     (avant : il etait cache dessous).
 * Desktop : inchange (reglages Help Scout : icone + texte, a gauche).
 * Le z-index reste celui du theme (6) : le bouton passe sous les menus et le panier ouverts.
 * Fonctionne pour les 3 Beacons (FR / EN / NL) initialises dans layout/theme.liquid.
 */
(function () {
  if (typeof window === 'undefined' || typeof window.Beacon !== 'function') return;

  var mq = window.matchMedia('(max-width: 989px)');

  var style = document.createElement('style');
  style.textContent =
    '@media screen and (max-width: 989px) {' +
    '#beacon-container .BeaconFabButtonFrame {' +
    'left: 16px !important; right: auto !important;' +
    'bottom: calc(16px + var(--pulse-beacon-offset, 0px)) !important;' +
    'transition: bottom 0.25s ease, box-shadow 250ms, opacity 0.4s !important;' +
    '}' +
    '}';
  document.head.appendChild(style);

  function applyStyle() {
    window.Beacon('config', { display: { style: mq.matches ? 'icon' : 'iconAndText' } });
  }

  function updateOffset() {
    var offset = 0;
    var bar = document.querySelector('.product-sticky-bar');
    if (mq.matches && bar && getComputedStyle(bar).display !== 'none') {
      var rect = bar.getBoundingClientRect();
      if (rect.height > 0 && rect.top < window.innerHeight) {
        offset = Math.max(0, Math.round(window.innerHeight - rect.top));
      }
    }
    document.documentElement.style.setProperty('--pulse-beacon-offset', offset + 'px');
  }

  applyStyle();
  if (mq.addEventListener) {
    mq.addEventListener('change', function () {
      applyStyle();
      updateOffset();
    });
  }

  window.addEventListener('scroll', updateOffset, { passive: true });
  window.addEventListener('resize', updateOffset);
  window.addEventListener('load', updateOffset);
  setInterval(updateOffset, 1000);
})();
